import {   
  FETCH_PIPELINE_BEGIN,
 FETCH_PIPELINE_SUCCESS,
 FETCH_PIPELINE_FAILURE ,
} from "../constants/pipeline";


const initialState={
    Pipelinedata: [],
    isPipelinedataLoading:false,
    Pipelinedataerror:"",
    
}
export const getPipelineReducer = (state = initialState, action) => {
    debugger;
    const { type, payload } = action;
    
    switch (type) {
        case FETCH_PIPELINE_BEGIN:
            return {
                ...state,
                isPipelinedataLoading: true,
                
                Pipelinedataerror:null,
            };
        case FETCH_PIPELINE_SUCCESS:
            return {
                ...state,
                isPipelinedataLoading: false,
                Pipelinedata: payload.Pipelinedata,
                Pipelinedataerror:null,
            };
        case FETCH_PIPELINE_FAILURE:
            return {
                ...state,
                isPipelinedataLoading: true,
                Pipelinedataerror: payload.errorMessage,
                Pipelinedata: [],
            };
        

        default :
        return state;
    }
}
export default getPipelineReducer
